import { render, staticRenderFns } from "./business-school.vue?vue&type=template&id=e088dba6&scoped=true&"
import script from "./business-school.vue?vue&type=script&lang=js&"
export * from "./business-school.vue?vue&type=script&lang=js&"
import style0 from "./business-school.vue?vue&type=style&index=0&id=e088dba6&prod&lang=less&"
import style1 from "./business-school.vue?vue&type=style&index=1&id=e088dba6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e088dba6",
  null
  
)

export default component.exports